import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import FlagIcon from "vue-flag-icon";
import i18n from "@/plugins/i18n";
import VueCookie from "vue-cookie";
import VueHead from "vue-head";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import PackageJson from "../package.json";
import ExtraPage from "@/components/ExtraPage.vue";
import Extra from "@/components/Extra.vue";
import "highlight.js/styles/github.css";

Vue.config.productionTip = false;

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://663fb3a68f5547daa917e8c67fa790c8@sentry.io/1833497",
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    release: PackageJson.version,
    environment: process.env.NODE_ENV
  });
}

Vue.prototype.$log = console.log.bind(console);

Vue.use(FlagIcon);
Vue.use(VueCookie);
Vue.use(VueHead);

const app = new Vue({
  components: { Extra, ExtraPage },
  data: { loading: false },
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");

router.beforeEach((to, from, next) => {
  app.loading = true;
  return next();
});

router.afterEach(() => {
  app.loading = false;
});
